import Utils from "../../../shared/utils";
import { TrackingPayload } from "./tracking-payload.interface";

export class PurchasePayload implements TrackingPayload {
    constructor(
        public orderId: string,
        public items: { id: number; quantity: number; }[],
        public currencySymbol: string,
        public value: number,
        public shipping?: number,
        public paymentMethod?: string,
        public orderType?: string,
    ) { }

    public toMetaFormat(): Record<string, any> {
        const currency = Utils.mapCurrencyToIsoCode(this.currencySymbol);

        return {
            content_ids: this.items.map(i => i.id),
            contents: this.items.map(i => ({
                id: i.id,
                quantity: i.quantity,
            })),
            value: this.value,
            ...(currency && { currency }),
            ...(this.shipping && { shipping: this.shipping }),
            ...(this.paymentMethod && { payment_method: this.paymentMethod }),
            ...(this.orderId && { order_id: this.orderId }),
            ...(this.orderType && { order_type: this.orderType }),
        };
    }
}